import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useAssetSectionStyle = createUseStyles({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
        fontWeight: 500,
    },
    balanceName: {
        color: color.content.primary,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    button: {
        width: '100%',
        height: '44px',
        border: 0,
        backgroundColor: color.background.primary,
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
        margin: '8px 0 20px 0',
        fontWeight: 600,
        fontSize: fontSize.md,

        '& svg': {
            width: 20,
            height: 20,
            marginRight: spacing['02'],
        },

        '&:hover': {
            backgroundColor: color.background.fourth,
        },
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '10px 0',
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '8px',
    },
    error: {
        color: color.content.negative,
        marginTop: spacing['02'],
    },
});
